export default __webpack_public_path__ + "61f1077fdeb78ec3387215d0e1e5ac99.png";